// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__wJCB0","checkboxCol":"Table_checkboxCol__VtDbr","emailCol":"Table_emailCol__3KLJ7","actionCol":"Table_actionCol__nVE7z"};